<template>
	<button class="bl-icon-button bl-collection-remove" type="button" @click="blFormCollectionValue.removeValue(blFormCollectionIndex())" v-if="show()" tabindex="-1">{{ icon }}</button>
</template>

<script>
export default {
	name: 'BlCollectionRemove',
	inject: ['blFormCollectionValue', 'blFormCollectionIndex'],
	props: {
		icon: {
			type: String,
			default: 'delete'
		}
	},
	methods: {
		show() {
			return !this.blFormCollectionValue.options.required || this.blFormCollectionValue.value.length > 1
		}
	}
}
</script>

<style scoped lang="scss">
button {
	padding: 4px;
}
</style>